// 위드비컨 샴푸 productID
// 1: "Moisture.zip",
// 2: "Nourisher.zip",
// 3: "노모어오일 샴푸",
// 4: "비컨피던트 샴푸",
// 5: "커션 슬리퍼리 트리트먼트",
// 8: "기브미워터 샴푸",
// 11: "린언미 샴푸",
export default Object.freeze({
  GENERAL: 4,
  OILY: 3,
  DRY: 8,
  SENSITIVITY: 8,
  SEBORRHEIC: 11,
  TREATMENT: 5,
  AMPLE: 2,
  ESSENCE: 1,
  DRY_AND_OILY: 8, //수부지
});
export const Category = {
  SHAMPOO: 'SHAMPOO',
  TREATMENT: 'TREATMENT',
  NUTRIENTS: 'NUTRIENTS',
  ESSENCE: 'ESSENCE',
  AMPLE: 'AMPLE',
  ETC: 'ETC',
};
//========== 두피 타입 ==========//
export const ScalpType = {
  UNKNOWN: 'UNKNOWN', //모름
  GENERAL: 'GENERAL', //일반
  OILY: 'OILY', //지성
  DRY: 'DRY', //건성
  SENSITIVITY: 'SENSITIVITY', //민감성
  SEBORRHEIC: 'SEBORRHEIC', //지루성
  DRY_AND_OILY: 'DRY_AND_OILY', //수부지 -> 수분 부족형 지성.
};
// products response ↓
// 0: {id: 1, name: 'Moisture.zip', category: 'ESSENCE', description_img: null, abstract: '모이스쳐집', …}
// 1:
// abstract: "너리셔집"
// badge: "NEW"
// category: "AMPLE"
// description: "너리셔집 에센스"
// description_img: null
// discount_percent: 0
// id: 2
// name: "Nourisher.zip"
// productItemVariations: Array(2)
// 0: {id: 2, product_id: 2, container_volume: '30ml', price: 13000}
// 1: {id: 28, product_id: 2, container_volume: '30ml', price: 16000}
// length: 2
// [[Prototype]]: Array(0)
// sell_status: false
// sub_description: "구독가격 11,050"
// [[Prototype]]: Object
// 2:
// abstract: "노모어오일"
// badge: "NEW"
// category: "SHAMPOO"
// description: "노모어오일 샴푸"
// description_img: null
// discount_percent: 0
// id: 3
// name: "No More Oil"
// productItemVariations: Array(3)
// 0: {id: 3, product_id: 3, container_volume: '360ml', price: 15000}
// 1: {id: 16, product_id: 3, container_volume: '30ml', price: 0}
// 2: {id: 23, product_id: 3, container_volume: '360ml', price: 18000}
// length: 3
// [[Prototype]]: Array(0)
// sell_status: true
// sub_description: "구독가격 12,750"
// [[Prototype]]: Object
// 3:
// abstract: "비컨피던트"
// badge: "NEW"
// category: "SHAMPOO"
// description: "비컨피던트 샴푸"
// description_img: null
// discount_percent: 0
// id: 4
// name: "Be Confident"
// productItemVariations: Array(3)
// 0: {id: 4, product_id: 4, container_volume: '360ml', price: 15000}
// 1: {id: 17, product_id: 4, container_volume: '30ml', price: 0}
// 2: {id: 22, product_id: 4, container_volume: '360ml', price: 18000}
// length: 3
// [[Prototype]]: Array(0)
// sell_status: true
// sub_description: "구독가격 12,750"
// [[Prototype]]: Object
// 4:
// abstract: "커션:슬리퍼리"
// badge: "NEW"
// category: "TREATMENT"
// description: "커션슬리퍼리 트리트먼트"
// description_img: null
// discount_percent: 0
// id: 5
// name: "Caution:Slippery"
// productItemVariations: (3) [{…}, {…}, {…}]
// sell_status: false
// sub_description: "구독가격 12,750"
// [[Prototype]]: Object
// 5:
// abstract: "기브미워터"
// badge: "NEW"
// category: "SHAMPOO"
// description: "기브미워터 샴푸"
// description_img: null
// discount_percent: 0
// id: 8
// name: "Give Me Water"
// productItemVariations: Array(4)
// 0: {id: 6, product_id: 8, container_volume: '360ml', price: 17000}
// 1: {id: 10, product_id: 8, container_volume: '360ml', price: 17000}
// 2: {id: 18, product_id: 8, container_volume: '30ml', price: 0}
// 3: {id: 24, product_id: 8, container_volume: '360ml', price: 20000}
// length: 4
// [[Prototype]]: Array(0)
// sell_status: true
// sub_description: "구독가격 14,450"
// [[Prototype]]: Object
// 6:
// abstract: "린언미"
// badge: "NEW"
// category: "SHAMPOO"
// description: "린언미 샴푸"
// description_img: null
// discount_percent: 0
// id: 11
// name: "Lean on Me"
// productItemVariations: Array(4)
// 0: {id: 7, product_id: 11, container_volume: '360ml', price: 17000}
// 1: {id: 14, product_id: 11, container_volume: '360ml', price: 17000}
// 2: {id: 19, product_id: 11, container_volume: '30ml', price: 0}
// 3: {id: 25, product_id: 11, container_volume: '360ml', price: 20000}
// length: 4
// [[Prototype]]: Array(0)
// sell_status: true
// sub_description: "구독가격 14,450"
